import { Suspense, lazy, useEffect, useState } from 'react';
import { Skeleton } from '@/components/ui/skeleton';
import { setErnaehrungClient, clearErnaehrungClient } from '@/lib/ernaehrungClient';
import { ErnaehrungStart } from '@/pages/CoachErnaehrung';
import { CoachErnaehrungCockpit } from '@/pages/CoachErnaehrungCockpit';
import { CoachErnaehrungKunden } from '@/pages/CoachErnaehrungKunden';
import { LinkUmleitung } from '@/pages/CoachErnaehrungTeile';

/* Ernährungscoaching komplett auf /coach (15.10.2026): EIN Einstieg für alle Ernährungs-Ansichten der Trainer-Webseite.
   Beim Betreten wird der Ernährungs-Client der CRM-Karten auf den Trainer-Client umgestellt
   (`setErnaehrungClient(coach, '/x')` — danach gehen ernaehrungAPI, gewohnheitenAPI, freigabenAPI, aufgabenAPI,
   checkinsAPI.suche und bildSrc über `/api/coach/x/...` mit Trainer-Token), beim Verlassen zurück. Die Karten selbst
   kommen unverändert aus dem CRM; Links darin (auf CRM-Seiten) werden hier abgefangen und auf `gehe()` umgebogen.
   Rollen entscheidet der Server: 403 erscheint als Satz, nie als Absturz. Gemeinsame Teile: CoachErnaehrungTeile.js. */

const CoachErnaehrungAutomatik = lazy(() => import('@/pages/CoachErnaehrungAutomatik'));
const CoachErnaehrungKochbuecher = lazy(() => import('@/pages/CoachErnaehrungKochbuecher'));
const CoachErnaehrungEinstellungen = lazy(() => import('@/pages/CoachErnaehrungEinstellungen'));

export const E_ANSICHTEN = ['ernaehrung', 'e-cockpit', 'e-kunden', 'e-automatik', 'e-kochbuecher', 'e-einstellungen'];
export const istErnaehrung = (id) => E_ANSICHTEN.includes(id);

const Laden = () => <div className="space-y-3" aria-busy="true"><Skeleton className="h-24 w-full rounded-[14px]" /><Skeleton className="h-64 w-full rounded-[14px]" /></div>;

export default function CoachErnaehrungBereich({ coach, ich, ansicht, params, gehe, q }) {
  // Erst umschalten, dann die Karten einhängen: Effekte der Kinder liefen sonst vor dem Umschalter (Kinder zuerst)
  const [bereit, setBereit] = useState(false);
  useEffect(() => {
    setErnaehrungClient(coach, '/x');
    setBereit(true);
    return () => { clearErnaehrungClient(); };
  }, [coach]);
  if (!bereit) return <Laden />;
  const kunde = (id) => gehe({ ansicht: 'e-kunden', mitglied: id, reiter: 'uebersicht' });
  let inhalt;
  if (ansicht === 'e-cockpit') inhalt = <CoachErnaehrungCockpit coach={coach} ich={ich} kunde={params.kunde} panel={params.panel} gehe={gehe} />;
  else if (ansicht === 'e-kunden') inhalt = <CoachErnaehrungKunden coach={coach} ich={ich} mitglied={params.mitglied} reiter={params.reiter} gehe={gehe} q={q} />;
  else if (ansicht === 'e-automatik') inhalt = <Suspense fallback={<Laden />}><CoachErnaehrungAutomatik ich={ich} /></Suspense>;
  else if (ansicht === 'e-kochbuecher') inhalt = <Suspense fallback={<Laden />}><CoachErnaehrungKochbuecher ich={ich} /></Suspense>;
  else if (ansicht === 'e-einstellungen') inhalt = <Suspense fallback={<Laden />}><CoachErnaehrungEinstellungen ich={ich} /></Suspense>;
  else inhalt = <ErnaehrungStart coach={coach} onWahl={kunde} />;
  return <LinkUmleitung gehe={gehe}><div data-testid="coach-e-bereich">{inhalt}</div></LinkUmleitung>;
}
